import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Typography,
  Tooltip,
  Divider,
  Card,
} from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import CustomButton from "../../../../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text, Title } = Typography;

const NewRelatioship = (props) => {
  const navigate = useNavigate();
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [genderOptions, setGenderOptions] = useState([]);
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const [professionOptions, setProfessionOptions] = useState([]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_FAMILYMEMBERS") && getTemplate();
    console.log(state);
  }, []);

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  function getTemplate() {
    const url = `${apiConfig.Clients}/${state.key}/familymembers/template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        let tempGender = [];
        let tempRelationship = [];
        let tempProfession = [];
        let tempMaritalStatus = [];

        console.log(objList);

        objList?.genderIdOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.relationshipIdOptions?.forEach((element) => {
          tempRelationship.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.professionIdOptions?.forEach((element) => {
          tempProfession.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.maritalStatusIdOptions?.forEach((element) => {
          tempMaritalStatus.push({
            value: element.id,
            label: element.name,
          });
        });

        setGenderOptions(tempGender);
        setRelationshipOptions(tempRelationship);
        setProfessionOptions(tempProfession);
        setMaritalStatusOptions(tempMaritalStatus);

        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/detail-customer", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Clients}/${state.key}/familymembers`;

    formValues.dateOfBirth = BOM.DateTime(formValues.dateOfBirth, "only-date");

    const body = {
      ...formValues,
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newRelationshipCreatedMsg);
          navigate("/detail-customer", { state });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-customer", { state });
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newRelationship}
        pageItems={staticConfig.newRelationshipBreadcrumbItems}
      />
      <Card
        headStyle={{ borderBottomWidth: 0 }}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Form
          initialValues={{
            active: false,
            isStaff: false,
          }}
          form={form}
          layout="vertical"
          onFinish={onSubmit}
        >
          <Row>
            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.generalInfo}
            </Title>
          </Row>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />

          <Row style={{ justifyContent: "space-between" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.firstName}
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.firstName} `),
                  },
                ]}
              >
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.firstName)} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.middleName} name="middleName">
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.middleName)} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.lastName}
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.lastName} `),
                  },
                ]}
              >
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lastName)} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.qualification} name="qualification">
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.qualification)} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.mobileNumber}
                name="mobileNumber"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.mobileNumber} `),
                  },
                  () => ({
                    validator(_, value) {
                      if (value === undefined || value === null || String(value).trim() === "") {
                        return Promise.resolve();
                      }
                      const v = String(value).trim();
                      if (v.length !== 11) {
                        return Promise.reject(new Error("Mobile number must be exactly 11 digits"));
                      }
                      if (!/^[0-9]{11}$/.test(v)) {
                        return Promise.reject(new Error("Mobile number must contain only numbers"));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.mobileNumber)} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.bvn}
                name="bvn"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.bvn} `),
                  },
                  () => ({
                    validator(_, value) {
                      if (value === undefined || value === null || String(value).trim() === "") {
                        return Promise.resolve();
                      }
                      const trimmed = String(value).trim();
                      if (trimmed.length !== 11) {
                        return Promise.reject(
                          new Error(`${labelConfig.bvn} must be exactly 11 digits`),
                        );
                      }
                      if (!/^[0-9]{11}$/.test(trimmed)) {
                        return Promise.reject(
                          new Error(`${labelConfig.bvn} must contain only digits`),
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  maxLength={11}
                  inputMode="numeric"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.bvn)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.nin}
                name="nin"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.nin} `),
                  },
                  () => ({
                    validator(_, value) {
                      if (value === undefined || value === null || String(value).trim() === "") {
                        return Promise.resolve();
                      }
                      const trimmed = String(value).trim();
                      if (trimmed.length !== 11) {
                        return Promise.reject(
                          new Error(`${labelConfig.nin} must be exactly 11 digits`),
                        );
                      }
                      if (!/^[0-9]{11}$/.test(trimmed)) {
                        return Promise.reject(
                          new Error(`${labelConfig.nin} must contain only digits`),
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  maxLength={11}
                  inputMode="numeric"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.nin)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.age} name="age">
                <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.age)} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.isDependent} name="isDependent">
                <Checkbox />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.relationshipType}
                name="relationshipId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.relationshipType} `),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.relationshipType}`,
                    "select",
                  )}
                  options={relationshipOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.gender} name="genderId">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.gender}`, "select")}
                  options={genderOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.profession} name="professionId">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.profession}`, "select")}
                  // options={productOptions}
                  options={professionOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.maritalStatus} name="maritalStatusId">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.maritalStatus}`, "select")}
                  options={maritalStatusOptions}
                  // options={productOptions}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.dateOfBirth}
                name="dateOfBirth"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(`${labelConfig.dateOfBirth} `),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%", height: 32.5, marginBottom: 0 }}
                  className="bond-date-picker custom-input"
                  disabledDate={disabledAfterCurrentDate}
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.dateOfBirth}`, "select")}
                  // style={{ width: "100%", height: 32.5, marginBottom: 0 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <div></div>
            </Col>
          </Row>

          <Row>
            <Divider />
            {BOM.HasPermission("CREATE_FAMILYMEMBERS") && (
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
                // onClick={onSubmit}
              />
            )}
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps)(NewRelatioship);
